import { Div, Switch } from '@tblabs/truffle';
import { OnlineStorage } from '@tblabs/storage';
import { Song } from '../Models/Song';
import { MusicPlayer } from '../Services/MusicPlayer';
import { PlaylistProvider } from '../Services/PlaylistProvider';
import { Icons } from '../Utils/Icons';
import { SvgButton } from '../Components/SvgButton';
import { SelectableList } from '../Models/SelectableList';
import { SelectableListPrinter } from '../Components/SelectableListPrinter';
import { PlaybackControler } from '../Components/PlaybackControler';
import { PlayerLogic } from '../Components/PlayerLogic';
import { PlaylistSelector } from '../Components/PlaylistSelector';
import { Env } from '../Models/Env';
import { EnvDetector } from '../Services/EnvDetector';
import { MenuWindow } from '../Components/MenuWindow';


export class PlayerPage extends Div
{
    constructor()
    {
        super("player-page");
    }

    public async OnAppend()
    {
        const _envDetector = new EnvDetector();
        const storageUrl = new Switch<Env, string>(_envDetector.Env)
            .Case(Env.Local, () => 'http://localhost/storageV5/')
            .Case(Env.Stage, () => 'https://stage.storage.specteam.pl/v5/')
            .Case(Env.Prod, () => 'https://storage.specteam.pl/v5/')
            .Default(() => 'https://storage.specteam.pl/v5/')
            .Execute() || "";

        const _storage = new OnlineStorage(storageUrl, "Music");
        const _playlistProvider = new PlaylistProvider(_storage);
        const _musicPlayer = new MusicPlayer();
        const _songsList = new SelectableList<Song>([]);
        const _playerLogic = new PlayerLogic(_playlistProvider, _songsList, _musicPlayer);

        this.Append(
            new Div().Style(`display: flex; align-items: center; justify-content: center; gap: 8px;`).Append(
                new PlaylistSelector(_playerLogic),
                new SvgButton(Icons.Menu).OnClick(() => new MenuWindow(_playerLogic, _playlistProvider)),
            ),
            new SelectableListPrinter(_songsList, song => song.Name).Style(`flex: 1; overflow-y: auto;`),
            new PlaybackControler(_playerLogic),
        );

        await _playlistProvider.Init();
        _playerLogic.Init();
    }
}
